import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, LoginPageState } from '@rms/auth';
import { catchError, throwError } from 'rxjs';

export const authErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === HttpStatusCode.Unauthorized && req.headers.has('Authorization')) {
        auth.clearSession();
        const state: LoginPageState = { message: 'auth.errors.expired' };
        router.navigate(['/login'], { state });
      }

      return throwError(() => error);
    })
  );
};
